export default "__VITE_ASSET__6VeYndcT__"